import React from "react";
import { Box } from "@mui/material";

// What a job is, for labels. Uninstalls and replacements were called installs almost
// everywhere in the QE and installer screens (N8).
const JOB_TYPE = {
  NEW: { label: "Install", noun: "Install", color: "#4ade80" },
  UN: { label: "Uninstall", noun: "Uninstall", color: "#f87171" },
  RE: { label: "Replacement", noun: "Replacement", color: "#a78bfa" },
};

export function jobType(install_state) {
  return JOB_TYPE[install_state] || JOB_TYPE.NEW;
}

// The serial the job is about: the device coming off for an uninstall, the one going on otherwise.
export function jobSerial(card) {
  return card.install_state === "UN" ? card.archived_serial_number : card.serial_number;
}

export function JobTypeTag({ install_state }) {
  const { label, color } = jobType(install_state);
  return (
    <Box
      component="span"
      sx={{
        display: "inline-block",
        fontSize: "0.68rem",
        fontWeight: 700,
        letterSpacing: "0.05em",
        textTransform: "uppercase",
        color,
        border: `1px solid ${color}55`,
        borderRadius: "6px",
        px: "6px",
        py: "1px",
      }}
    >
      {label}
    </Box>
  );
}
